module.exports = __webpack_public_path__ + "static/media/vscanvas.cc367f22.png";